export class BlogFilter {
    constructor(validFrom?: Date, validTo?: Date){
        this.validFrom = validFrom;
        this.validTo = validTo;
    }

    validFrom?: Date;
    validTo?: Date;
}